import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const CustomerVisitorContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="web-visitor-content">
      <div className="datenschutz-container">
        <section className="datenschutz-section">
          <h2>1. {t('customerVisitorOverview')}</h2>
          <div className="datenschutz-content">
            <h3>{t('customerVisitorGeneral')}</h3>
            <p>{t('customerVisitorGeneralText')}</p>
            <h3 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorDataCollection')) }}></h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorResponsibleText')) }}></p>
          </div>
        </section>
        <section className="datenschutz-section">
          <h2>2. {t('customerVisitorGeneralNotes')}</h2>
          <div className="datenschutz-content">
            <h3>{t('customerVisitorPrivacy')}</h3>
            <p>{t('customerVisitorPrivacyText')}</p>

            <h3>{t('customerVisitorPurpose')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorPurposeText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>3. {t('customerVisitorRecipients')}</h2>
          <div className="datenschutz-content">
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorRecipientsText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>4. {t('customerVisitorYourRights')}</h2>
          <div className="datenschutz-content">
            <h3>{t('customerVisitorWithdrawConsent')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorWithdrawConsentText')) }}></p>

            <h3>{t('customerVisitorRightToObject')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorRightToObjectText')) }}></p>
            
            <h3>{t('customerVisitorComplaintRight')}</h3>
            <p>{t('customerVisitorComplaintRightText')}</p>
            
            <h3>{t('customerVisitorDataPortability')}</h3>
            <p>{t('customerVisitorDataPortabilityText')}</p>
            
            <h3>{t('customerVisitorAccessBlockDelete')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorAccessBlockDeleteText')) }}></p>
            
            <h3>{t('customerVisitorRestrictionRight')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorRestrictionRightText')) }}></p>
            
            <h3>{t('customerVisitorObjectAdvertising')}</h3>
            <p>{t('customerVisitorObjectAdvertisingText')}</p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>5. {t('customerVisitorDataProtectionOfficer')}</h2>
          <div className="datenschutz-content">
            <h3>{t('customerVisitorStatutoryOfficer')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorStatutoryOfficerText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>6. {t('customerVisitorFurtherInfo')}</h2>
          <div className="datenschutz-content">
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('customerVisitorFurtherInfoText')) }}></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CustomerVisitorContent;
